import { JobStatus } from '../utils/enums.js';
/** Permissions required for non-cancel job status transitions. */
export const JOB_STATUS_UPDATE_PERMISSIONS = ['jobs:update', 'jobs:manage'];
/** Permissions required for cancel transitions (jobs:manage implies delete via permission aliases). */
export const JOB_STATUS_CANCEL_PERMISSIONS = ['jobs:delete'];
/** Admin-only revert of accidental job start (IN_PROGRESS → SCHEDULED). */
export const JOB_STATUS_ADMIN_REVERT_PERMISSIONS = ['jobs:delete'];
export const JOB_STATUS_WORKFLOW = [
    {
        from: JobStatus.DRAFT,
        to: JobStatus.SCHEDULED,
        requiredPermissions: [...JOB_STATUS_UPDATE_PERMISSIONS],
        requiredFields: ['customerId', 'scheduledDate', 'serviceAddress'],
        notifications: ['customer_job_scheduled', 'assigned_user_notification']
    },
    {
        from: JobStatus.SCHEDULED,
        to: JobStatus.IN_PROGRESS,
        requiredPermissions: [...JOB_STATUS_UPDATE_PERMISSIONS],
        requiredFields: ['assignedUserId', 'actualStartTime'],
        requiresCustomerContact: true,
        notifications: ['customer_job_started']
    },
    {
        from: JobStatus.IN_PROGRESS,
        to: JobStatus.ON_HOLD,
        requiredPermissions: [...JOB_STATUS_UPDATE_PERMISSIONS],
        requiredFields: ['notes'],
        notifications: ['customer_job_delayed', 'manager_notification']
    },
    {
        from: JobStatus.ON_HOLD,
        to: JobStatus.IN_PROGRESS,
        requiredPermissions: [...JOB_STATUS_UPDATE_PERMISSIONS],
        notifications: ['customer_job_resumed', 'assigned_user_notification']
    },
    {
        from: JobStatus.IN_PROGRESS,
        to: JobStatus.COMPLETED,
        requiredPermissions: [...JOB_STATUS_UPDATE_PERMISSIONS],
        requiredFields: ['actualEndTime', 'completedDate'],
        requiresCustomerContact: true,
        notifications: ['customer_job_completed']
    },
    {
        from: JobStatus.IN_PROGRESS,
        to: JobStatus.SCHEDULED,
        requiredPermissions: [...JOB_STATUS_ADMIN_REVERT_PERMISSIONS],
        notifications: ['assigned_user_notification']
    },
    {
        from: JobStatus.DRAFT,
        to: JobStatus.CANCELLED,
        requiredPermissions: [...JOB_STATUS_CANCEL_PERMISSIONS],
        notifications: ['customer_job_cancelled']
    },
    {
        from: JobStatus.SCHEDULED,
        to: JobStatus.CANCELLED,
        requiredPermissions: [...JOB_STATUS_CANCEL_PERMISSIONS],
        notifications: ['customer_job_cancelled']
    },
    {
        from: JobStatus.ON_HOLD,
        to: JobStatus.CANCELLED,
        requiredPermissions: [...JOB_STATUS_CANCEL_PERMISSIONS],
        notifications: ['customer_job_cancelled']
    }
];
//# sourceMappingURL=job.js.map